import LoginRecommend from '../constants/LoginRecommend';
const loginRequirementRecord = {
  loginRequirement: {
    loginType: LoginRecommend.HUBSPOT,
    hardRequirement: false
  },
  hasSsoRequirement: false,
  stagedEmail: '',
  stagedRememberLogin: false,
  useDark: false,
  loginRedirectUrl: undefined,
  allowFbSignup: false,
  hideSignupLink: false,
  signupParams: undefined,
  pageId: undefined
};

const validateRecomendedResponse = (response, data, queryData) => Object.assign({}, loginRequirementRecord, {}, response, {
  stagedEmail: data.email,
  stagedRememberLogin: data.rememberLogin
}, queryData);

export default validateRecomendedResponse;